module.exports = __webpack_public_path__ + "23852b0c5dc59c8d16369168ce50709b.svg";